module.exports = __webpack_public_path__ + "img/bg08.903ba7d9.gif";